import * as Yup from 'yup'

const validationSchema = Yup.object({
  SR_No: Yup.string(),
  Product: Yup.string().required('Required'),
  Quantity: Yup.string().required('Required'),
  Jetty: Yup.string().required('Required'),
  Status: Yup.string().required('Required'),
  Client: Yup.string().required('Required'),
  Activity: Yup.string().required('Required'),
  Vessel_Name: Yup.string().required('Required'),
  Duration: Yup.string(),
  // Duration is calculated and not user input, so no validation needed
  All_Fast: Yup.date()
    .required('Required')
    .nullable()
    .typeError('Invalid date')
    .test(
      'is-before-cast-off',
      'All Fast must be before Cast Off/Depart',
      function (value) {
        const { Cast_Off } = this.parent
        if (!value || !Cast_Off) return true // skip if either is empty
        return new Date(value) < new Date(Cast_Off)
      }
    ),
  Cast_Off: Yup.date()
    .required('Required')
    .nullable()
    .typeError('Invalid date')
    .test(
      'is-greater',
      'Cast Off/Depart must be greater than All Fast/Arrival',
      function (value) {
        const { All_Fast } = this.parent
        if (!value || !All_Fast) return true // skip if either is empty
        return new Date(value) > new Date(All_Fast)
      }
    ),
  Laycan_Start: Yup.date()
    .required('Required')
    .nullable()
    .typeError('Invalid date')
    .test(
      'is-before-laycan-end',
      'Laycan Start must be before Laycan End',
      function (value) {
        const { Laycan_End } = this.parent
        if (!value || !Laycan_End) return true // skip if either is empty
        return new Date(value) < new Date(Laycan_End)
      }
    ),
  Laycan_End: Yup.date()
    .required('Required')
    .nullable()
    .typeError('Invalid date')
    .test(
      'is-greater',
      'Laycan Finish must be greater than Laycan Start',
      function (value) {
        const { Laycan_Start } = this.parent
        if (!value || !Laycan_Start) return true // skip if either is empty
        return new Date(value) > new Date(Laycan_Start)
      }
    ),
})

export default validationSchema